import Cookies from 'js-cookie';

import { HttpClient } from 'shared/libs/http';
import { TelegramStatsResponse } from './telegram-stats.types';

export class TelegramStatsApiService {
   public static async load() {
      const tokenKey = Cookies.get('token');
      const adminID = Cookies.get('adminID');

      return await HttpClient.get<TelegramStatsResponse>('/admin/telegram/dashboard', {
         headers: {
            adminid: adminID,
            Authorization: `Bearer ${tokenKey}`,
         },
      });
   }
}
